// extracted by mini-css-extract-plugin
export default {"container":"NodeIcon_container__+6FrM","icon":"NodeIcon_icon__l3W5z","color":"NodeIcon_color__OC9I1"};